import { render, staticRenderFns } from "./chooseFeeCombo.vue?vue&type=template&id=0626ea8a&scoped=true"
import script from "./chooseFeeCombo.vue?vue&type=script&lang=js"
export * from "./chooseFeeCombo.vue?vue&type=script&lang=js"
import style0 from "./chooseFeeCombo.vue?vue&type=style&index=0&id=0626ea8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626ea8a",
  null
  
)

export default component.exports